import { compose } from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../../actions/SeminarManagementViewer';
import withAuth from '../../common/WithAuth';
import ListSeminarViewer, { Header } from '../../pages/SeminarManagementViewer/ListSeminarViewer';

const mapStateToProps = (state) => {
    const isLoading = state.seminarManagementViewer.listSeminarViewer.isFetching
    || state.seminarManagementViewer.registerSeminarViewer.isFetching
    || state.seminarManagementViewer.detailSeminarViewer.isFetching
    || state.registration.registrationViewer.isFetching
    || state.adminSettingCustom.getCustomText.isFetching;

    return ({
        locale: state.locale.lang.current,
        langOther: state.locale?.changLangOther?.current || '',
        language: state.locale.changeLanguage.lang?.language || 'ja',
        detailSeminar: state.seminarManagementViewer.detailSeminarViewer.data,
        listSeminarViewer: state.seminarManagementViewer.listSeminarViewer.data.results,
        listPagination: state.seminarManagementViewer.listSeminarViewer.data,
        detailSeminarViewer: state.seminarManagementViewer.detailSeminarViewer.data,
        registerStatus: state.seminarManagementViewer.registerSeminarViewer.registerStatus,
        idRegister: state.seminarManagementViewer.registerSeminarViewer.data,
        isLoading,
        eventInfo: state.registration.registrationViewer.data,
        isAuthorized: state.auth.credential.isAuthorized,
        isWeakAuth: state.auth.credential.data?.isWeakAuth,
        errorRegister: state.seminarManagementViewer.registerSeminarViewer.errors,
        customText: state.adminSettingCustom.getCustomText.data?.content,
        customColor: state.registrationOrganizer.registrationOrganizer.data?.settings_colors_viewer,
    });
};

const mapDispatchToProps = (dispatch) => ({
    fetchListSeminarViewer: (params) => {
        dispatch(Actions.GetListSeminarRequested(params));
    },
    registerSeminarRequested: (params) => {
        dispatch(Actions.RegisterSeminarRequested(params));
    },
    getDetailSeminarViewer: (params) => {
        dispatch(Actions.GetDetailSeminarRequested(params));
    },
    clearListSeminarViewer: () => {
        dispatch(Actions.ClearListSeminar());
    },
    clearRegisterSeminar: () => {
        dispatch(Actions.ClearRegisterSeminar());
    },
    clearDetailSeminarViewer: () => {
        dispatch(Actions.ClearDetailSeminar());
    },
});

export const ListSeminarHeader = connect(mapStateToProps, mapDispatchToProps)(Header);

export default compose(
    withAuth,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(ListSeminarViewer);
